import React, { useContext, useMemo } from 'react';

import { CoCurricularApi } from '../apis/co-curricular/co-curricular.api';
import { AdminCoCurricularApi } from '../apis/co-curricular/admin-co-curricular.api';
import { api } from '../api';

const CoCurricularApiContext = React.createContext(new CoCurricularApi(api));

export const CoCurricularApiProvider = CoCurricularApiContext.Provider;
export const useCoCurricularApi = (): CoCurricularApi =>
  useContext(CoCurricularApiContext);

// Build an admin-scoped co-curricular API bound to a target student. Wrap the
// subtree in <CoCurricularApiProvider value={adminApi}> so the existing
// transcript components render that student's record for an executive admin.
export const useAdminCoCurricularApi = (userId: string): AdminCoCurricularApi =>
  useMemo(() => new AdminCoCurricularApi(api, userId), [userId]);
